module.exports = __webpack_public_path__ + "static/media/Peacer.07b49f4b.png";